import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal, setSEO } from "@/components/Reveal";
import { PRODUCTS, IMAGES } from "@/lib/data";

const ProductBlock = ({ p, flip }) => (
    <section className="py-20 md:py-28 border-t border-white/10 first:border-t-0" data-testid={`product-${p.num}`}>
        <div className="sf-container grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <Reveal className={flip ? "lg:order-2" : ""}>
                <div className="sf-image-frame group" data-testid={`product-image-${p.num}`}>
                    <img src={IMAGES[p.image]} alt={p.title} className={`w-full h-[440px] group-hover:scale-105 transition-transform duration-700 ${p.contain ? "object-contain bg-white" : "object-cover"}`} />
                    <div className="absolute inset-0 bg-gradient-to-t from-sf-black/50 to-transparent pointer-events-none" />
                    <div className="absolute top-0 left-0 bg-sf-black/80 backdrop-blur px-4 py-2 font-mono text-[10px] tracking-[0.25em] uppercase text-sf-green border-b border-r border-white/10">
                        {p.tag}
                    </div>
                </div>
            </Reveal>
            <div className={flip ? "lg:order-1" : ""}>
                <Reveal>
                    <p className="font-mono text-sf-green text-sm">{p.num}</p>
                    <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-[0.95] tracking-tight text-white mt-4">
                        {p.title}
                    </h2>
                    <p className="text-sf-silver text-base leading-relaxed mt-6 max-w-lg">{p.text}</p>
                    <ul className="mt-8 space-y-3">
                        {p.items.map((item) => (
                            <li key={item} className="flex items-center gap-3 text-white/80 text-sm" data-testid={`product-item-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                                <Check size={14} className="text-sf-green shrink-0" /> {item}
                            </li>
                        ))}
                    </ul>
                    <Link to="/contact" data-testid={`product-enquire-${p.num}`} className="sf-btn-ghost mt-10">
                        Enquire About This Product <ArrowUpRight size={16} />
                    </Link>
                </Reveal>
            </div>
        </div>
    </section>
);

export default function Products() {
    useEffect(() => {
        setSEO("Products — Super Finishers", "Precision tubular components, automotive components, cycle parts and custom manufacturing solutions from an ISO 9001:2015 certified facility.");
    }, []);

    return (
        <>
            <PageHero
                overline="Our Products"
                titleLines={["Components That", "Carry the Load."]}
                description="Precision-manufactured products for shock absorber, automotive and cycle industries — built to drawing, proven in production."
                image="machinery"
            />
            {PRODUCTS.map((p, i) => (
                <ProductBlock key={p.num} p={p} flip={i % 2 === 1} />
            ))}
        </>
    );
}
